// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgSolarChargingIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M8 4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1 0 2.21-1.79 4-4 4S8 6.21 8 4m3 7v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1m8-6h1c.55 0 1-.45 1-1s-.45-1-1-1h-1c-.55 0-1 .45-1 1s.45 1 1 1M4 5h1c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1m16 14H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1M4.93 11.07c.2.2.45.29.71.29s.51-.1.71-.29l1.41-1.41a.996.996 0 1 0-1.41-1.41L4.94 9.66a.996.996 0 0 0 0 1.41zm11.31-1.41 1.41 1.41c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-1.41-1.41a.996.996 0 1 0-1.41 1.41z" />
  </g>
);
export default SvgSolarChargingIcon;
SvgSolarChargingIcon.displayName = 'SvgSolarChargingIcon';
